import React, { useEffect } from 'react'
import { SubmitHandler, useForm } from 'react-hook-form'

import { successMessages } from '@/constants/feedbackMessages'
import { Button, Input, ModalBase, NumberInput } from '@components/atoms'
import { yupResolver } from '@hookform/resolvers/yup'
import { editInfochema } from '@schemas/settings/index.schema'
import { dashboardAPI } from '@services/DashboardAPI'
import { modalCreators } from '@store/ducks/modal'
import { notificationCreators } from '@store/ducks/notification'
import { useAppDispatch, useAppSelector } from '@store/hooks'
import moment from 'moment'

type Inputs = {
	name: string
	birthdate: string
	whatsapp: string
	phone: string
	email: string
	cpfCnpj: string
}

export const EditInfo = () => {
	const dispatch = useAppDispatch()
	const [editInfo, { isLoading, isSuccess }] =
		dashboardAPI.useEditInfoMutation()

	const {
		modal: { modalName, modalInfo },
	} = useAppSelector((state) => state)

	const {
		register,
		reset,
		setValue,
		handleSubmit,
		formState: { errors },
	} = useForm<Inputs>({
		mode: 'onBlur',
		resolver: yupResolver(editInfochema),
	})

	const onSubmit: SubmitHandler<Inputs> = (data) => {
		editInfo({
			name: data.name,
			birthdate: moment(data?.birthdate).format('YYYY-MM-DD'),
			whatsapp: data.whatsapp || '',
			phone: data.phone || '',
			cep: modalInfo?.cep,
			street: modalInfo?.street,
			number: modalInfo?.number,
			district: modalInfo?.district,
			city: modalInfo?.city,
			uf: modalInfo?.uf,
		})
		dispatch(modalCreators.closeModal())
		reset()
	}

	useEffect(() => {
		if (modalInfo) {
			setValue('name', modalInfo?.name)
			setValue('cpfCnpj', modalInfo?.cpfCnpj || '')
			setValue('email', modalInfo?.email)
			setValue('phone', modalInfo?.phone || '')
			setValue('whatsapp', modalInfo?.whatsapp || '')
			setValue(
				'birthdate',
				moment.utc(modalInfo?.birthdate).format('YYYY-MM-DD')
			)
		}
	}, [modalInfo, setValue])

	useEffect(() => {
		if (isSuccess) {
			dispatch(notificationCreators.show(successMessages.updatedInfo))
		}
	}, [dispatch, isSuccess])

	return (
		<ModalBase
			title='Editar Informações pessoais'
			open={modalName === 'editInfo'}
		>
			<form
				onSubmit={handleSubmit(onSubmit)}
				style={{ width: '100%', marginTop: '32px' }}
			>
				<Input
					placeholder='Nome'
					error={errors.name?.message}
					{...register('name')}
					css={{ marginBottom: '24px', color: '$neutral120' }}
				/>

				<Input
					placeholder='Email'
					{...register('email')}
					disabled
					css={{ marginBottom: '24px' }}
				/>

				<Input
					placeholder='Data de nascimento'
					error={errors.birthdate?.message}
					{...register('birthdate')}
					css={{ marginBottom: '24px', color: '$neutral120' }}
					type='date'
					defaultValue={moment.utc(modalInfo?.birthdate).format('YYYY-MM-DD')}
				/>
				<NumberInput
					placeholder='CPF'
					{...register('cpfCnpj')}
					onValueChange={(v) => setValue('cpfCnpj', v.value)}
					defaultValue={modalInfo?.cpfCnpj || ''}
					css={{ marginBottom: '24px' }}
					format='###.###.###-##'
					disabled
				/>

				<NumberInput
					placeholder='Telefone'
					error={errors.phone?.message}
					{...register('phone')}
					css={{ marginBottom: '24px', color: '$neutral120' }}
					onValueChange={(v) => setValue('phone', v.value)}
					defaultValue={modalInfo?.phone || ''}
					format='(##) #####-####'
				/>

				<NumberInput
					placeholder='Whatsapp'
					error={errors.whatsapp?.message}
					{...register('whatsapp')}
					css={{ marginBottom: '32px', color: '$neutral120' }}
					onValueChange={(v) => setValue('whatsapp', v.value)}
					defaultValue={modalInfo?.whatsapp || ''}
					format='(##) #####-####'
				/>

				<div style={{ display: 'flex', gap: '26px', marginTop: '34px' }}>
					<Button loading={isLoading}>Salvar</Button>
				</div>
			</form>
		</ModalBase>
	)
}
